import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { Box } from "@mui/material";
import { ragVideoPreviewUrl } from "../../../chat-assistance/services/ragChatApi";
import type { DocumentRowUi } from "../../types/documentManagementUiTypes";
import { VideoMetadataThumbnail } from "../shared/VideoMetadataThumbnail";
import {
  canPreviewLibraryVideo,
  isLibraryPdfRow,
  isLibraryVideoRow,
} from "../../utils/documentLibraryMediaUtils";

export type LibraryFileTypeIconProps = {
  row: DocumentRowUi;
};

function LibraryVideoThumbFallback() {
  return (
    <Box className="dm-library-video-thumb__inner">
      <PlayCircleOutlineIcon className="dm-library-video-thumb__play" />
    </Box>
  );
}

/** File-type glyph beside library row names (PDF red, video 16:9 frame or icon). */
export function LibraryFileTypeIcon({ row }: LibraryFileTypeIconProps) {
  if (isLibraryVideoRow(row)) {
    const previewSrc = canPreviewLibraryVideo(row.upload_status)
      ? ragVideoPreviewUrl(row.original_file_name)
      : "";

    return (
      <Box className="dm-library-video-thumb" aria-hidden>
        {previewSrc ? (
          <VideoMetadataThumbnail
            src={previewSrc}
            videoClassName="dm-library-video-thumb__video"
            fallback={<LibraryVideoThumbFallback />}
          />
        ) : (
          <LibraryVideoThumbFallback />
        )}
      </Box>
    );
  }

  if (isLibraryPdfRow(row)) {
    return (
      <Box
        className="dm-library-file-icon dm-library-file-icon--pdf"
        aria-hidden
      >
        <PictureAsPdfIcon className="dm-library-file-icon__pdf" />
      </Box>
    );
  }

  return (
    <Box
      className="dm-library-file-icon dm-library-file-icon--document"
      aria-hidden
    >
      <DescriptionOutlinedIcon className="dm-library-file-icon__page" />
    </Box>
  );
}
